$ = require 'jquery'
Storage = require 'lib/storage'
TrelloModel = require 'models/internal/trello-model'
Language = require('common/lib/language').default

module.exports = class Announcement extends TrelloModel
  typeName: 'Announcement'

  constructor: (attr) ->
    super

  _key: -> "announcement-#{ @id }-read"

  isUnread: ->
    !Storage.get(@_key())

  markRead: ->
    $.post('/announcements/dismiss', { id: @id })
    Storage.set(@_key(), true)
    @trigger('change:unread')

  getLocale: ->
    Language.normalizeLocale(@get('locale') || 'en')

  matchesLocale: (locale) ->
    Language.matches locale, @getLocale()



// WEBPACK FOOTER //
// ./app/scripts/models/announcement.coffee